import { TextEditorPage as PlatformTextEditorPage } from '@jarvis/platform-ui';

export function TextEditorPage() {
  return <PlatformTextEditorPage filesLinkTo="/files" filesLinkLabel="Files" />;
}
